import { PatchManagementWebComponent } from './component/PatchManagementWebComponent';

export { PatchManagementWebComponent };
